import MinhaContaAPI from '@/api/minhaconta'
import AuthAPI from '@/api/auth'
import useJwt from '@/auth/jwt/useJwt'

const handleAuthUser = (commit, resolve, reject) => {
  MinhaContaAPI.getConta()
    .then(res => {
      const userData = {
        ability: [
          {
            subject: 'Auth',
            action: 'read',
          },
          {
            subject: 'Home',
            action: 'read',
          },
        ],
      }

      res.data.ability = userData.ability

      commit('SET_AUTH_USER', res.data)
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
}

export default {
  fetchLogout({ commit }) {
    localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
    localStorage.removeItem('userData')
    localStorage.removeItem('authUser')
    commit('SET_AUTH_USER', {})
  },

  trocarConta({ commit }, empresaId) {
    return new Promise((resolve, reject) => {
      AuthAPI.trocarConta(empresaId)
        .then(response => {
          useJwt.setToken(response.data.access_token)
          handleAuthUser(commit, resolve, reject)
        })
        .catch(error => {
          if (error.response && error.response.status === 412) {
            reject(new Error('Sua conta não possui vínculo com esta empresa'))
          } else {
            reject(error)
          }
        })
    })
  },
  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const credenciais = {
        email: payload.userDetails.email,
        senha: payload.userDetails.password,
      }
      AuthAPI.login(credenciais)
        .then(response => {
          if (response.data) {
            useJwt.setToken(response.data.access_token)
            handleAuthUser(commit, resolve, reject)
          } else {
            reject(new Error('Email or senha inválidos'))
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 412) {
            reject(new Error('Email or senha inválidos'))
          } else {
            reject(error)
          }
        })
    })
  },
  loginGoogle({ commit }, user) {
    return new Promise((resolve, reject) => {
      // valida o token do Goodle
      AuthAPI.loginSocial({ code: user.tc.id_token, referral: 'google' })
        .then(res => {
          useJwt.setToken(res.data.access_token)
          // obtem dados da conta
          handleAuthUser(commit, resolve, reject)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginFacebook({ commit }, user) {
    return new Promise((resolve, reject) => {
      AuthAPI.loginSocial({ code: user.accessToken, referral: 'facebook' })
        .then(res => {
          useJwt.setToken(res.data.access_token)
          handleAuthUser(commit, resolve, reject)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginOAuth({ commit }, code) {
    return new Promise((resolve, reject) => {
      AuthAPI.loginOAuth(code)
        .then(response => {
          useJwt.setToken(response.data.access_token)
          handleAuthUser(commit, resolve, reject)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  registerUserJWT({ commit }, payload) {
    const {
      displayName,
      email,
      password,
      confirmPassword,
    } = payload.userDetails
    return new Promise((resolve, reject) => {
      if (password !== confirmPassword) {
        reject(
          new Error(
            'Senha diferente da Confirmação de Senha. Tente novamente.',
          ),
        )
      }
      AuthAPI.cadastro(displayName, email, password)
        .then(response => {
          useJwt.setToken(response.data.access_token)
          commit('SET_AUTH_USER', response.data.userData)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
